import React from 'react';
import { Button as DSButton } from '../../components/DesignSystem/components/Button';
import { Heading, Text } from '../../components/DesignSystem/components/Typography';
import { Container, Section, Grid } from '../../components/DesignSystem/components/Layout';
import { Navbar } from '../../components/DesignSystem/components/Navbar';
import { Footer } from '../../components/DesignSystem/components/Footer';
import OptimizedImage from '../../components/OptimizedImage/OptimizedImage';
import '../../components/DesignSystem/styles/tokens.css';
import '../../components/userflow/components/card/card.css';
import './SuccessStories.css';

// Import Assets
import st2 from '../../assets/images/st2.png';
import st3 from '../../assets/images/st3.png';
import st4 from '../../assets/images/st4.png';
import st5 from '../../assets/images/st5.png';
import st6 from '../../assets/images/st6.png';

const stories = [
    {
        id: 1,
        name: "Abi & John",
        description: "Abi & John Bonded Over Faith & Their Tamil-German-British Connection...",
        image: st2,
        link: "https://tamilculture.com/mytamildate-success-abi-john-bonded-over-faith-their-tamil-german-british-connection"
    },
    {
        id: 2,
        name: "Jenani & Nav",
        description: "Jenani & Nav Found Each Other At The Right Time And Right Place In Life...",
        image: st3,
        link: "https://tamilculture.com/mytamildate-love-story-jenani-nav-found-each-other-at-the-right-time-and-right-place-in-life"
    },
    {
        id: 3,
        name: "Agi & Ano",
        description: "Agi’s First Attempt With Online Dating Led Her To Soulmate Ano....",
        image: st4,
        link: "https://tamilculture.com/mytamildate-success-agis-first-attempt-with-online-dating-led-her-to-soulmate-ano"
    },
    {
        id: 4,
        name: "Celine & Santhous",
        description: "A Gentle Push Towards Online Dating By Family Brought Céline & Santhous Together....",
        image: st5,
        link: "https://tamilculture.com/mytamildate-success-a-gentle-push-towards-online-dating-by-family-brought-celine-santhous-together"
    },
    {
        id: 5,
        name: "Suji & Sinthu",
        description: "Suji & Sinthu's journey Is A Heartwarming Example Of Patience And Taking ....",
        image: st6,
        link: "https://tamilculture.com/mytamildate-love-story-patience-and-taking-chances-brought-suji-sinthu-together"
    }
];

const SuccessStoryCard = ({ story, delay }) => {
    return (
        <div className="story-card-wrapper fade-up" style={{ animationDelay: `${delay}ms` }}>
             <div className="story-outer-card" onClick={() => window.open(story.link, '_blank')}>
                {/* Image Section */}
                <div className="card-and-details-container success-card-static">
                  <div
                    className="card-container show"
                    style={{
                      backgroundImage: `linear-gradient(0.05deg, #000000 -1.48%, rgba(0, 0, 0, 0.1) 29.79%, rgba(0, 0, 0, 0) 99.96%), url(${story.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  >
                    <div className="details-container" style={{ width: "100%" }}>
                      <div className="details" style={{ marginLeft: "1rem", marginBottom: "1rem" }}>
                        <p style={{ marginBottom: "0px" }}>
                          <span style={{ fontSize: "32px", fontWeight: "600", lineHeight: "48px" }}>
                            {story.name}
                          </span>
                        </p>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "0.5rem" }}>
                          <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>favorite</span>
                          <p style={{ fontSize: "small", opacity: 0.9 }}>Success Story</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Content Section */}
                <div className="story-custom-content">
                    <Text className="story-card-description">{story.description}</Text>
                    <div className="read-more-link">
                        Read Story
                        <span className="material-symbols-outlined text-sm">arrow_forward</span>
                    </div>
                </div>
             </div>
        </div>
    );
};

const SuccessStories = () => {
    return (
        <div className="success-stories-page font-display">
            <Navbar />
            
            <header className="success-hero-container">
                <Container>
                    <div className="success-hero-card fade-up">
                        <div className="hero-gradient-orb"></div>
                        <div className="hero-content-wrapper">
                            <div className="flex items-center gap-2 mb-6">
                                <span className="h-px w-8 bg-brand"></span>
                                <span className="text-brand uppercase tracking-widest text-xs font-bold">MTD Love Stories</span>
                            </div>
                            <Heading variant="h1" className="text-5xl lg:text-7xl font-black text-slate-900 mb-6 leading-tight">
                                Real People, Real <span className="text-brand">Connections.</span>
                            </Heading>
                            <br/>
                            <Text size="lg" className="text-slate-600 leading-relaxed text-xl max-w-2xl">
                                Matches are made daily and serious relationships are created monthly across North America, 
                                Europe, and beyond. Get to know some of our couples.
                            </Text>
                        </div>
                    </div>
                </Container>
            </header>

            <Section className="success-grid-section">
                <Container>
                    <div className="success-cards-grid">
                        {stories.map((story, index) => (
                            <SuccessStoryCard key={story.id} story={story} delay={index * 100} />
                        ))}
                    </div>
                </Container>
            </Section>

            <Section className="success-cta-section">
                <Container>
                    <div className="success-hero-card fade-up lp-text-center">
                        <div className="hero-gradient-orb" style={{ top: 'auto', bottom: '-20%', left: '-10%', right: 'auto' }}></div>
                        <div className="hero-content-wrapper lp-p-8 lg:lp-p-12">
                            <Heading variant="h2" className="text-4xl lg:text-5xl font-black mb-6">Start Your Own Story</Heading>
                            <br/>
                            <Text size="lg" className="text-slate-600 mb-10 max-w-2xl mx-auto text-xl">
                                Join the community where meaningful connections through shared culture and values happen every day.
                            </Text>
                            <br/>
                            <div className="flex flex-col sm:flex-row gap-4 justify-center">
                                <DSButton to="/signup" variant="primary" size="lg" className="px-12 py-4">
                                    Join myTamilDate
                                    <span className="material-symbols-outlined">arrow_forward</span>
                                </DSButton>
                            </div>
                        </div>
                    </div>
                </Container>
            </Section>

            <Footer />
        </div>
    );
};

export default SuccessStories;
